import React, { useEffect, useState, useRef } from 'react';
import { ChevronDownIcon } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Esto funciona de verdad o es otro timo de internet?',
    a: 'Entiendo la desconfianza — hay mucho engaño ahí fuera. Por eso existe la garantía de 14 días. Descárgate el método, prueba las recetas, intenta vender tus primeros flanes. Si no funciona, te devuelvo cada dólar sin preguntar nada. No tengo ningún incentivo en venderte algo que no funciona.'
  }, {
    q: '¿Puedo vender flanes en mi ciudad?',
    a: 'Sí. Los flanes sin horno funcionan porque son diferentes a lo que compra todo el mundo. No compites con la pastelería — ofreces algo casero, artesanal y especial. Grupos del barrio, Wallapop, Instagram, mercadillos, encargos para cumpleaños... hay más canales de venta de los que crees.'
  }, {
    q: '¿Hace falta experiencia cocinando?',
    a: 'Ninguna. Si sabes mezclar ingredientes y meter algo en la nevera, puedes hacer estos flanes. Están diseñados para que salgan perfectos desde la primera vez, aunque nunca hayas cocinado para vender.'
  }, {
    q: '¿Cómo obtengo acceso?',
    a: 'Inmediatamente después del pago recibes un email con el enlace de descarga. Todo es digital — sin esperas, sin envíos.'
  }, {
    q: '¿Hay cargo mensual?',
    a: 'No. Es un pago único de $17. El material es tuyo para siempre.'
  }, {
    q: '¿De verdad no necesito horno ni baño María?',
    a: 'Cero horno. Cero baño María. Todo en frío — mezclas los ingredientes y a la nevera. En menos de 15 minutos tienes la producción lista. Sin gas, sin esperas, sin que se hundan.'
  }, {
    q: '¿Por qué está tan barato si incluye tanto?',
    a: 'Estamos en fase de lanzamiento y necesitamos testimonios reales de mujeres que usen el método. Por eso el precio es de acceso. Una vez tengamos los primeros resultados documentados, el precio sube a $37 y los bonos se venden por separado.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-8 md:py-20 px-4 bg-white border-t border-gray-200" data-id="element-76">
      <div className="max-w-3xl mx-auto" data-id="element-77">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-center text-brown-dark mb-5 md:mb-12" data-id="element-78">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-2 md:space-y-4" data-id="element-79">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-[10px] shadow-[0_2px_8px_rgba(0,0,0,0.08)] border border-gray-100 overflow-hidden" data-id="element-80">
              <button className="w-full px-4 py-3.5 md:px-6 md:py-5 text-left flex justify-between items-center focus:outline-none min-h-[48px] hover:bg-green-50/50 transition-colors" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-81">
                <span className="font-heading font-bold text-base md:text-lg text-brown-dark pr-3" data-id="element-82">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-gray-400 flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180 text-caramel' : ''}`} data-id="element-83" />
              </button>

              <div className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-84">
                <div className="px-4 pb-3.5 md:px-6 md:pb-5 text-sm md:text-base text-gray-700 font-medium" data-id="element-85">
                  <div className="w-full h-px bg-gray-100 mb-3" data-id="element-86"></div>
                  {faq.a}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}